import React from 'react';
import { OrderStatus } from '@/types';
import { BaseStatusIndicatorProps } from '.';
import Indicator, { IndicatorColor } from '@/components/Indicator';
import { useLingui } from '@lingui/react';

interface OrderStatusIndicatorProps extends BaseStatusIndicatorProps {
    value: OrderStatus;
    isBuyer?: boolean;
}

const colorMap: { [key in OrderStatus]: IndicatorColor } = {
    Pending: 'warning',
    ReadyToStart: 'success',
    Rejected: 'danger',
    Canceled: 'secondary',
    Completed: 'info',
    InProgress: 'info',
};

const OrderStatusIndicator: React.FC<OrderStatusIndicatorProps> = ({ value, isBuyer = false, children, ...rest }) => {
    const { _ } = useLingui();

    return (
        <Indicator color={colorMap[value]} {...rest}>
            {children || _({ id: `OrderStatus.${value}` })}
        </Indicator>
    );
};

export default OrderStatusIndicator;
